<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>
</div>

<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="!isSecondPage" class="firstPage">
      <form class="ui form" [formGroup]="selectForm">
        <div class="field">
          <sui-radio-button
            formControlName="notificationType"
            [value]="'slack'"
          >
            Slack
          </sui-radio-button>
        </div>
        <div class="field">
          <sui-radio-button
            formControlName="notificationType"
            [value]="'email'"
          >
            Email
          </sui-radio-button>
        </div>
      </form>
    </div>

    <div *ngIf="isSecondPage || !modal.context.data.isAdd" class="secondPage">
      <form class="ui form" [formGroup]="notificationForm">
        <div
          class="field"
          [ngClass]="displayFieldCss('name')"
          appMargin
          marginB="15px"
        >
          <label class="required">Notification Name</label>
          <input type="text" formControlName="name" />
          <app-field-error-display
            [displayError]="isFieldValid('name')"
            errorMsg="Please provide a valid name"
          >
          </app-field-error-display>
        </div>

        <div
          *ngIf="
            selectedType === 'email' ||
            this.modal.context.data.showEmailField == true
          "
          class="field"
          [ngClass]="displayFieldCss('email')"
          appMargin
          marginB="15px"
        >
          <label class="required">Email</label>
          <input type="text" formControlName="email" />
          <app-field-error-display
            [displayError]="isFieldValid('email')"
            errorMsg="Please provide a valid email"
          >
          </app-field-error-display>
        </div>

        <div
          *ngIf="
            selectedType === 'email' ||
            this.modal.context.data.showEmailField == true
          "
          class="field"
          [ngClass]="displayFieldCss('subject')"
          appMargin
          marginB="15px"
        >
          <label class="required">Subject</label>
          <input type="text" formControlName="subject" />
          <app-field-error-display
            [displayError]="isFieldValid('subject')"
            errorMsg="Please provide an email subject"
          >
          </app-field-error-display>
        </div>

        <div
          class="field"
          [ngClass]="displayFieldCss('description')"
          appMargin
          marginB="15px"
        >
          <label class="required">Description</label>
          <input
            type="text"
            formControlName="description"
            style="height: 120px !important"
          />
          <app-field-error-display
            [displayError]="isFieldValid('description')"
            errorMsg="Please provide a description"
          >
          </app-field-error-display>
        </div>
        <div
          *ngIf="
            selectedType == 'slack' ||
            (this.modal.context.data &&
              this.modal.context.data.showEmailField == false)
          "
          class="field"
          [ngClass]="displayFieldCss('channel')"
          appMargin
          marginB="15px"
        >
          <label class="required"
            >Select Channels to receive notifications</label
          >
          <div class="ui fluid multiple selection dropdown" suiDropdown>
            <input type="hidden" name="channel" [value]="selectedChannelIds" />
            <i class="dropdown icon"></i>
            <div class="default text" *ngIf="selectedChannels.length === 0">
              Select Channels
            </div>
            <div class="text" *ngIf="selectedChannels.length > 0">
              {{ getSelectedChannelsText() }}
            </div>
            <div class="menu" suiDropdownMenu>
              <div
                *ngFor="let channel of channels"
                class="item"
                [class.selected]="isChannelSelected(channel)"
                (click)="toggleChannelSelection(channel)"
              >
                <i
                  class="check box icon"
                  *ngIf="isChannelSelected(channel)"
                ></i>
                <span>{{ channel.name }}</span>
              </div>
            </div>
          </div>

          <app-field-error-display
            [displayError]="isFieldValid('channel')"
            errorMsg="Please provide a valid Value"
          >
          </app-field-error-display>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="actions" style="background: transparent; border: none">
  <button
    *ngIf="!isSecondPage"
    class="ui basic primary button"
    (click)="modal.deny(undefined)"
  >
    Cancel
  </button>
  <button
    *ngIf="!isSecondPage"
    class="ui primary button"
    [disabled]="!selectForm.valid"
    (click)="proceedToSecondPage()"
  >
    Continue
  </button>

  <button
    *ngIf="isSecondPage"
    class="ui basic primary button"
    (click)="modal.deny(undefined)"
  >
    Cancel
  </button>
  <button
    *ngIf="
      isSecondPage && this.modal.context.data.isAdd && selectedType == 'slack'
    "
    (click)="addNewSettings()"
    [disabled]="pending || !notificationForm.valid"
    class="ui primary button"
  >
    Save
  </button>
  <button
    *ngIf="
      isSecondPage && this.modal.context.data.isAdd && selectedType == 'email'
    "
    (click)="addNewSettings()"
    [disabled]="pending || !isFormValidForEmail()"
    class="ui primary button"
  >
    Save
  </button>
  <button
    *ngIf="isSecondPage && !this.modal.context.data.isAdd"
    (click)="editSetting()"
    [disabled]="pending"
    class="ui primary button"
  >
    Save
  </button>
</div>
